/** Custom hook to provide all the Media popover functionality */
import { useRef } from "react";
import { i18n } from "../../utils/GadgetUtils";
import { svgToPng } from "../../utils/SvgToPngConverter";
import { getCustomIconText, getMediaLayout } from "../../utils/TaskUtils";

const useMediaPopOverSetup = () => {
    const mediaPropertiesLayouts = useRef();
    const mediaDomainList = useRef([]);
    const popOverIdsMap = useRef({});
    const dialogIdToPopOverMap = useRef({});
    const queueIncomingDialogsBeforeInit = useRef({});
    const isInited = useRef(false);
    const digitalChannelSetupRef = useRef();

    let containerService = window.finesse.containerservices.ContainerServices.init(),

    channelService = window.finesse.digital.ChannelService.init(containerService),

    popOverService = window.finesse.containerservices.PopoverService.init(containerService);

    function getPopOverIconSprite(icon, custom = false, text = '') {
        console.log('::-  MediaPopover getPopOverIconSprite ', icon, custom, text);
        if (!custom) {
            return (
                <svg focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox={icon.viewBox} fill="#fff" dangerouslySetInnerHTML={{__html:icon.value}} >
                </svg>
            )
        }
        return (
            <g>
                <circle style={{fill: '#CCCCCC', cx: '50%', cy: '50%', r: '50%'}}>
                </circle>
                <text style={{fontSize: 'inherit', fill: '#121212'}} x="50%" y="50%" textAnchor="middle" dy=".3em">{text}</text>
            </g>
        )
    }

    function getSvgString(icon, custom = false, text = '') {
        console.log('::-  MediaPopover getSvgString ', icon, custom, text);

        if (!custom) {
            return `<svg focusable='false' width="${icon.width}" height="${icon.height}" fill="${"white"}" xmlns="http://www.w3.org/2000/svg">
                        <g>${icon.value}</g>
                    </svg>`;
        }
        return `<svg width="72" height="72" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 72 72">
                    <g>
                    <circle style="fill:#CCCCCC;" cx="36" cy="36" r="36">
                    </circle>
                    <text style="font-size: 24px;fill:black" x="50%" y="50%" text-anchor="middle" dy=".3em">${text}</text>
                    </g>
                </svg>`;
    }

    function getSvg(mediaType, toaster = false) {
        const iconName = getIconName(mediaType, toaster);
        let icoDet = iconName && (window && window.top && window.top.cd && window.top.cd.core && window.top.cd.core.cdIcon && window.top.cd.core.cdIcon[iconName]);

        console.log('::-  MediaPopover getSvg1 ', mediaType, toaster, iconName, icoDet);
        if (icoDet) {
            return toaster ? getSvgString(icoDet) : getPopOverIconSprite(icoDet);
        }
        const text = getCustomIconText(mediaType);
        console.log('::-  MediaPopover getSvg2 ', text);

        return toaster ? getSvgString(icoDet, true, text) : getPopOverIconSprite(icoDet, true, text);
    }

    function getIconName(mediaType, toaster = false) {
        let iconName;
        switch(mediaType) {
            case 'chat':
                iconName = toaster ? 'mui-chat-circle-bw' : 'mui-chat-circle_bg';
                break;
            case 'email':
                iconName = toaster ? 'mui-email-circle-bw' : 'mui-email-circle_bg';
                break;
            case 'facebook':
                iconName = toaster ? 'mui-facebook-circle-bw' : 'mui-messenger-circle_bg';
                break;
            case 'sms':
                iconName = toaster ? 'mui-sms-circle-bw' : 'mui-sms-circle_bg';
                break;
            case 'whatsapp':
                iconName = toaster ? 'mui-whatsapp-circle-bw' : 'mui-whatsapp-circle_bg';
                break;
            default:
                break;
        }
        return iconName;
    }

    function getPopOverIconProp(mediatype) {
        let icon = {
            type: channelService.ICON_TYPE.COLLAB_ICON,
            value: getIconName(mediatype) || mediatype,
            isMediaPopOver: true,
            useSprite: true,
            iconSprite: getSvg(mediatype)
        };
        console.log('::-  MediaPopover getPopOverIconProp ', icon);
        return icon;
    }

    function getPopOverHeaderTitle(mediaType) {
        const TITLE_PREFIX = i18n.getMsg('gadget.imi.gadgetLoad.show.mediaPopover.title');
        let maxHeaderTitle = `${TITLE_PREFIX} ${mediaType}`;
        let minHeaderTitle = `${mediaType}`;

        return {
            maxHeaderTitle,
            minHeaderTitle
        }
    }

    function getBannerData(dialog) {
        const mediaLayout = getMediaLayout(dialog, mediaPropertiesLayouts.current);
        const showInPopOverVariables = getShowInPopOverVariables(mediaLayout, dialog.getMediaProperties());
        let bannerContent = getBannerContentFromPopOverVars(dialog.getMediaProperties(), mediaLayout, showInPopOverVariables);
        console.log('::-  MediaPopover getBannerData ', dialog, bannerContent);

        // Temporary statement added to show few call variables incase media properties layout doesn't have atleast one showInPopover fields as true
        // Should be removed later
        if (!(bannerContent.length)) {
            const dialogData = dialog.getData();
            bannerContent = dialogData.mediaProperties.callvariables.CallVariable.slice(0, 5);
        }

        let bannerData = {
            icon: {... getPopOverIconProp(getMediaType(dialog.getMediaProperties().mediaId).toLowerCase())},
            content: bannerContent,
            headerContent : getPopOverHeaderTitle(getMediaType(dialog.getMediaProperties().mediaId))
        };
        console.log('::-  MediaPopover getBannerData ', bannerData);
        return bannerData;
    }

    function getTimerData(dialog) {
        const timerData =  {
            displayTimeoutInSecs: getRingNoAnswerTime(dialog),
            display: true, // (channelId === chatChannelId)
            counterType: popOverService.COUNTER_TYPE.COUNT_DOWN
        };
        console.log('::-  MediaPopover _getTimerData ', timerData);
        return timerData;
    }

    function getActionData(dialog) {
        const fromAddress = dialog.getData().mediaProperties.callvariables.CallVariable[0].value || '';

        const mediaType = getMediaType(dialog.getMediaProperties().mediaId);
        const actionData = {};
            actionData.dismissible = false;
            actionData.buttons = [{
                id: "Accept",
                label: i18n.getMsg('gadget.imi.popover.accept'),
                type: "Affirm",
                hoverText: "",
                ariaLabel: `${i18n.getMsg('gadget.imi.popover.accept')} button ${getPopOverHeaderTitle(mediaType).maxHeaderTitle} from ${fromAddress}`
            }];
        return actionData;
    }

    function handleMedia(response) {
        console.log("::-  MediaPopover _handleMedia ", response);
        const popoverId = response.popoverId;
        const action = response.source;
        const dialog = popOverIdsMap.current[popoverId]?.dialog;

        // More cases maybe added moving forward depending on requirement
        switch(action) {
            case 'Accept':

                // setting the state to ACTIVE for the Task 
                dialog.setTaskState(finesse.restservices.MediaDialog.TaskActions.ACCEPT, {
                    success: function (res) {
                        console.log('success: Could move the task to ACCEPT state', res);
                    },
                    error: function (res) {
                        console.log('Error: Could not move the task to ACCEPT state', res);
                    }
                },
                null);
                break;
            case 'timeout':
                console.log("::-  MediaPopover _handleMedia popover timeout****** ", response);
                // digitalChannelSetupRef.current.handlePostRonaMediaState(dialog.getMediaProperties().mediaId);
                break;
            default:
                break;
        }
        dismissPopOver(dialog);
    }

    function popOverCallBack(response) {
        console.log("::-  MediaPopover popOverCallBack:Received popover callback with response ", response);
        handleMedia(response);
    }

    function getPopOverData(dialog) {
        return popOverIdsMap.current[dialogIdToPopOverMap.current[dialog.getId()]];
    }

    function UpdatePopOver(dialog) {
        const popOverData = getPopOverData(dialog);
        let newBannerData = {};
        newBannerData = {...popOverData.bannerData, content: getBannerData(dialog)};
        console.log('::-  MediaPopover UpdatePopOver ', newBannerData);

        popOverService.updatePopover(popOverData.popOverId, newBannerData, popOverData.timerData, popOverData.actionData);
    }

    function dismissPopOver(dialog) {
        console.log('::-  MediaPopover dismissPopOver before dismiss ', dialog, popOverService, popOverIdsMap.current, dialogIdToPopOverMap);
        popOverService.dismissPopover(dialogIdToPopOverMap.current[dialog.getId()]);
        delete popOverIdsMap.current[dialogIdToPopOverMap.current[dialog.getId()]];
        delete dialogIdToPopOverMap.current[dialog.getId()];
        delete queueIncomingDialogsBeforeInit.current[dialog.getData().id];
        console.log('::-  MediaPopover dismissPopOver after dismiss ', queueIncomingDialogsBeforeInit.current, popOverIdsMap.current, dialogIdToPopOverMap.current);

    }

    function getBannerContentFromPopOverVars(dialogMediaProperties, mediaLayout, PopOverVariablesObj) {
        console.log('::-  MediaPopover getBannerContentFromPopOverVars ', dialogMediaProperties, mediaLayout, PopOverVariablesObj);
        return [{
            name: mediaLayout.header.displayName,
            value: dialogMediaProperties[mediaLayout.header.mediaProperty] || ''
        }].concat(Object.keys(PopOverVariablesObj).map((displayName) => ({
            name: displayName,
            value: PopOverVariablesObj[displayName] || ''
        })));
    }

    function getShowInPopOverVariables(mediaLayout, dialogMediaProperties) {
        console.log('::-  MediaPopover getShowInPopOverVariables ', mediaLayout, dialogMediaProperties);
        let showInPopOverVariables = {};
        mediaLayout.columns.forEach(column => {
            column.forEach(variable => {
                if(variable.showInPopOver === 'true') {
                    showInPopOverVariables[variable.displayName] = dialogMediaProperties[variable.mediaProperty] ? dialogMediaProperties[variable.mediaProperty] : '';
                }
            })
        });
        return showInPopOverVariables;
    }

    function showPopOver(dialog) {
        // If showpopover is called before usemediapopover.init call, then store those dialogs to show later calling init
        if (!isInited.current) {
            queueIncomingDialogsBeforeInit.current[dialog.getData().id] = dialog;
            return;
        }
        const dialogData = dialog.getData();
        const dialogMediaProperties = dialog.getMediaProperties();
        console.log('::-  MediaPopover _showPopOver before popover ',dialogData, dialogMediaProperties);

        const bannerData = getBannerData(dialog);
        const timerData = getTimerData(dialog);
        const actionData = getActionData(dialog);
        const popOverId = popOverService.showPopover(bannerData, timerData, actionData, popOverCallBack);
        popOverIdsMap.current[popOverId] = {popOverId, mediaType: getMediaType(dialogMediaProperties.mediaId), bannerData, timerData, actionData, dialog};
        dialogIdToPopOverMap.current[dialog.getId()] = popOverId;
        console.log('::-  MediaPopover _showPopOver after popover ',dialog, dialogIdToPopOverMap.current, popOverIdsMap.current);
        const onclickHandler = function () {
            window.focus();
        };
        showToasterNotificationOnIncomingCall(dialog, onclickHandler);
    }

    function showToasterNotificationOnIncomingCall (dialog, onClickHandler) {
        let FinesseToaster = window.top.finesse.containerservices.FinesseToaster, toasterTitle, toasterBody;
        // get the localized totaster title
        let customerCV = dialog.getData().mediaProperties.callvariables.CallVariable[0];
       toasterTitle = i18n.getMsg('gadget.imi.gadgetLoad.show.toaster') + ' ' +
            (customerCV ? customerCV.value : '');
        // currently nothing should be displayed in Toaster body;
        toasterBody = '';
        let userDRMediaChannelName;
        for (const callVariable of dialog.getData().mediaProperties.callvariables.CallVariable){
            if (callVariable.name === 'user_DR_MediaChannelName') { 
                userDRMediaChannelName = callVariable.value;
            } 
        }
        const svg = getSvg(userDRMediaChannelName || dialog.getData().mediaChannel, true);
        console.log('::-  MediaPopover showToasterNotificationOnIncomingCall ', dialog, svg);

        const imgData = svgToPng(svg);
        FinesseToaster.showToaster(toasterTitle, {
            body: toasterBody,
            icon: `${imgData}`,
            showWhenVisible: false,
            tag: 'Incoming chat',
            onclick: onClickHandler
        });
    }

    // Function to showpopovers for dialogs that are passed to showpopover method even before calling usemediapopover.init()
    function showQueuedIncomingPopOvers () {
        console.log('::-  MediaPopover showQueuedIncomingPopOvers ', isInited, queueIncomingDialogsBeforeInit.current);
        if (!isInited.current) return;
        if (!Object.keys(queueIncomingDialogsBeforeInit.current).length) return;
        for (let dialogId in queueIncomingDialogsBeforeInit.current) {
            const dialog = queueIncomingDialogsBeforeInit.current[dialogId];
            showPopOver(dialog);
        }
    }

    function getMediaType(id) {
        let mediaDomain = mediaDomainList.current.find((media) => media.id === id);
        console.log('::-  MediaPopover getMediaType ', id, mediaDomain, mediaDomainList.current);

        return mediaDomain ? mediaDomain.channel : "Unknown";
    }
    
    function getRingNoAnswerTime(dialog) {
    	if(dialog.getMediaProperties()) {
    	    let id = dialog.getMediaProperties().mediaId
    	    let mediaDomain = mediaDomainList.current.find((media) => media.id === id);
            if (mediaDomain && mediaDomain.ringNoAnswerTime > 0) {
                const myParticipant = getMyParticipant(dialog);
                let computedRingNoAnswerTime = Number(mediaDomain.ringNoAnswerTime) - ((window.finesse.utilities.Utilities.currentServerTimeMillis() - Date.parse(myParticipant.startTime) )/ 1000);
                return (Math.round(computedRingNoAnswerTime) > Number(mediaDomain.ringNoAnswerTime) ? Number(mediaDomain.ringNoAnswerTime) : computedRingNoAnswerTime > 0 ? Math.round(computedRingNoAnswerTime) : Number(mediaDomain.ringNoAnswerTime))
            }
    	}
    	return 60;
    }

    function getMyParticipant (dialog) {
        const participant = dialog.getParticipants().filter(participant => participant.mediaAddress === window.finesse.container.Config.id);
        if (participant.length) {
            return participant[0];
        }
    }

    function configureAcceptTaskShortcutKey() {
        const shortCutKeyForAcceptTask = [{
            'id': 'cisco_imi_task_accept',
            'componentName': i18n.getMsg('gadget.imi.task.accept.componentname'),
            'actionName': i18n.getMsg('gadget.imi.task.accept.action'),
            'modifierKeys': window.finesse.shortcutkey.ShortcutKeyService.CONSTANTS.MODIFIER_KEYS.CTRL_ALT,
            'key': i18n.getMsg('gadget.imi.task.accept.action.key.9'),
            handler: () => {
                if (Object.keys(dialogIdToPopOverMap.current).length) {
                    const popOverData = popOverIdsMap.current[Object.values(dialogIdToPopOverMap.current)[0]];
                    if (popOverData.actionData.buttons && popOverData.actionData.buttons.length
                        && popOverData.actionData.buttons[0].id === 'Accept') {
                        const dialog = popOverData?.dialog;
                        // setting the state to ACTIVE for the Task 
                        dialog.setTaskState(finesse.restservices.MediaDialog.TaskActions.ACCEPT, {
                            success: function (res) { console.log('success: Could move the task to ACCEPT state', res); },
                            error: function (res) { console.log('Error: Could not move the task to ACCEPT state', res); }
                        }, null);
                        dismissPopOver(dialog);
                    }
                }
            }
        }];
        window.finesse.shortcutkey.ShortcutKeyService.registerShortcutKey(shortCutKeyForAcceptTask);
    }

    return {
        init: function(mediaPropertiesLayoutsCollection, digitalChannelSetup, mediaDomainListData) {
                console.log('::-  MediaPopover init', mediaPropertiesLayoutsCollection, digitalChannelSetup, mediaDomainListData);
                if (isInited.current) {
                    return;
                }
                // if (!(mediaPropertiesLayoutsCollection && digitalChannelSetup && mediaDomainListData)) {
                //     throw new Error('Invalid arguments supplied to useMediaPopOverSetup: Initialize method.');
                // }
                mediaPropertiesLayouts.current = mediaPropertiesLayoutsCollection;
                mediaDomainList.current = mediaDomainListData;
                digitalChannelSetupRef.current = digitalChannelSetup;
                isInited.current = true;
                // initialising shortcut key service
                window.finesse.shortcutkey.ShortcutKeyService.init();
                configureAcceptTaskShortcutKey();
                // show popover for queued dialogs which are passed to showpopover even before initing usemediapopover.init()
                showQueuedIncomingPopOvers();
        },
        showPopOver,
        dismissPopOver,
        UpdatePopOver,
        getMediaType
    }
}
export default useMediaPopOverSetup;